import React from 'react';
import { Heart, Plus, Pencil, Trash2 } from 'lucide-react';
import { Button } from '../ui/button';

export function WellnessServicesSection({ wellnessServices, onAdd, onEdit, onDelete }) {
    return (
        <div className="space-y-6" data-testid="welcome-wellness">
            <div className="flex justify-between items-center">
                <div>
                    <h2 className="text-2xl font-bold">Wellness Services</h2>
                    <p className="text-muted-foreground text-sm mt-1">
                        Health and wellbeing services available to residents
                    </p>
                </div>
                <Button onClick={onAdd} className="bg-teal-600 hover:bg-teal-700" data-testid="add-wellness-btn">
                    <Plus className="w-4 h-4 mr-2" />
                    Add Service
                </Button>
            </div>

            <div className="space-y-3">
                {wellnessServices.map((service) => (
                    <div key={service.id} className="card-base" data-testid={`wellness-card-${service.id}`}>
                        <div className="flex items-start gap-4">
                            <div className="w-12 h-12 rounded-lg bg-rose-100 flex items-center justify-center flex-shrink-0">
                                <Heart className="w-6 h-6 text-rose-600" />
                            </div>
                            <div className="flex-1 min-w-0">
                                <div className="flex items-center gap-2">
                                    <h3 className="font-semibold">{service.title}</h3>
                                    {service.bookable && (
                                        <span className="text-xs bg-green-100 text-green-700 px-2 py-0.5 rounded-full">
                                            Bookable
                                        </span>
                                    )}
                                </div>
                                <p className="text-sm text-muted-foreground">{service.description}</p>
                                <div className="flex flex-wrap gap-4 mt-2 text-sm">
                                    {service.price && (
                                        <span className="text-muted-foreground">
                                            <strong>Price:</strong> {service.price}
                                        </span>
                                    )}
                                    {service.duration_minutes && (
                                        <span className="text-muted-foreground">
                                            <strong>Duration:</strong> {service.duration_minutes} mins
                                        </span>
                                    )}
                                </div>
                            </div>
                            <div className="flex items-center gap-2">
                                <Button variant="ghost" size="sm" onClick={() => onEdit(service)} data-testid={`edit-wellness-${service.id}`}>
                                    <Pencil className="w-4 h-4" />
                                </Button>
                                <Button variant="ghost" size="sm" className="text-red-600 hover:text-red-700 hover:bg-red-50" onClick={() => onDelete(service)} data-testid={`delete-wellness-${service.id}`}>
                                    <Trash2 className="w-4 h-4" />
                                </Button>
                            </div>
                        </div>
                    </div>
                ))}
                {wellnessServices.length === 0 && (
                    <div className="text-center py-12 text-muted-foreground">
                        <Heart className="w-12 h-12 mx-auto mb-3 opacity-50" />
                        <p>No wellness services configured. Default services will be shown.</p>
                        <Button onClick={onAdd} className="mt-4" variant="outline">
                            <Plus className="w-4 h-4 mr-2" />
                            Add Your First Service
                        </Button>
                    </div>
                )}
            </div>
        </div>
    );
}

export default WellnessServicesSection;
